import { jsx } from 'react/jsx-runtime';
import { useState, useEffect, useCallback, createContext } from 'react';

/**
 * Default Options.
 */ const defaultOptions = {
    open: false,
    size: 'lg',
    disableClose: false,
    disableCloseOutside: false,
    disableBack: false
};
/**
 * Create Modal Context.
 */ const ModalContext = /*#__PURE__*/ createContext({
    ...defaultOptions,
    close: ()=>null
});
/**
 * Create Modal Provider.
 */ const ModalProvider = ({ children, open = defaultOptions.open, size = defaultOptions.size, disableClose = defaultOptions.disableClose, disableCloseOutside = defaultOptions.disableCloseOutside, disableBack = defaultOptions.disableBack, onCloseStart, onCloseEnd, onBack, coolwhip })=>{
    const [isOpen, setOpen] = useState(open);
    useEffect(()=>{
        // We need to update the internal state
        // when the `open` prop changes
        setOpen(open);
    }, [
        open
    ]);
    /**
     * Close Modal.
     */ const close = useCallback((e)=>{
        // Close only when not disabled
        if (!disableClose) {
            setOpen(false);
            onCloseStart?.(e);
        }
    }, [
        disableClose,
        onCloseStart
    ]);
    return jsx(ModalContext.Provider, {
        value: {
            // Pass internal state to replace prop
            open: isOpen,
            // Modal Options
            size,
            disableClose,
            disableCloseOutside,
            // Disable back button when forced and when `onBack` not exists
            disableBack: disableBack || onBack === undefined,
            // Event callbacks
            onCloseStart,
            onCloseEnd,
            onBack,
            // Context Specifics
            close,
            // Background
            coolwhip
        },
        children: children
    });
};
ModalProvider.displayName = 'Modal.Provider';

export { ModalContext, ModalProvider, defaultOptions };
//# sourceMappingURL=Modal.Context.es.js.map
